// @flow

import React from 'react'
import withPage from 'server/withPage'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { bindActionCreators } from 'redux'
import AccountTemplate from 'components/templates/AccountTemplate'
import { setUIState } from 'redux/modules/ui'
import { viewerFragment } from 'api/fragments'
import HostEntryPage from 'components/pages/HostEntryPage'
import {
  prefectureOptionList,
  tokyoRegionOptionList,
  regionOptionList,
  capacityOptionList,
  priceList,
} from 'stories/molecules/data'
import {
  actions as hostSimulationActions,
} from 'redux/modules/hostSimulation'
import { actions as accountActions } from 'redux/modules/account'
import { authUrlWithQuery } from 'helpers/format'
import { getAccountQueries } from 'helpers/format'
import LoadingView from 'components/atoms/LoadingView'
import Redirect from 'components/atoms/Redirect'
import Path from 'routes/path'
import queryString from 'query-string'
import { checkTokenExpired } from 'helpers/auth'
import { amplitudeLogEvent } from 'helpers/amplitude'

type PropTypes = {
  hostSimulation: {
    prefecture: string,
    region: string,
    capacity: string,
    price: string,
  },
  data: {
    viewer: {},
  },
  ui: {},
  actions: {
    setUIState: Function,
  },
  config: {},
}

class HostEntryPageContainer extends React.Component<PropTypes> {
  constructor(props: PropTypes) {
    super(props)
    this.resetSimulator = this.resetSimulator.bind(this)
    this.refetchSimulator = this.refetchSimulator.bind(this)
    this.getRegionList = this.getRegionList.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onHostRegistrationClick = this.onHostRegistrationClick.bind(this)
  }

  componentDidMount() {
    this.props.actions.setUIState({
      canSubmit: true,
    })
    amplitudeLogEvent('Start Host Registration')
  }

  getRegionList: Function
  getRegionList() {
    const { hostSimulation } = this.props
    if (hostSimulation.prefecture === '東京') {
      return tokyoRegionOptionList
    } else {
      return regionOptionList
    }
  }

  resetSimulator: Function
  resetSimulator(next) {
    const { actions, hostSimulation } = this.props

    if (next.prefecture === '東京') {
      next.region = '23区内'
    } else {
      next.region = '全て'
    }
    actions.setPrefecture(next)
    actions.setRegion(next)

    const params = {
      prefecture: next.prefecture || hostSimulation.prefecture,
      region: next.region || hostSimulation.region,
      capacity: next.capacity || hostSimulation.capacity,
    }

    const price = priceList[params.prefecture][params.region][params.capacity]
    actions.setPrice({ price: price })
  }

  refetchSimulator: Function
  refetchSimulator(next) {
    const { actions, hostSimulation } = this.props

    if (next.prefecture) {
      actions.setPrefecture(next)
    }
    if (next.region) {
      actions.setRegion(next)
    }
    if (next.capacity) {
      actions.setCapacity(next)
    }

    const params = {
      prefecture: next.prefecture || hostSimulation.prefecture,
      region: next.region || hostSimulation.region,
      capacity: next.capacity || hostSimulation.capacity,
    }

    const price = priceList[params.prefecture][params.region][params.capacity]
    actions.setPrice({ price: price })
  }

  onChange(e) {
    e.preventDefault()
    const [name, value] = [e.target.name, e.target.value]
    const payload = {}
    if (name === 'acceptTermOfService') {
      payload[name] = !this.props.account.acceptTermOfService
    } else if (name === 'acceptTermOfHost') {
      payload[name] = !this.props.account.acceptTermOfHost
    } else {
      payload[name] = value
    }
    this.props.actions.setAccount(payload)
  }

  onSubmit(e) {
    e.preventDefault()
    const { account, actions, config } = this.props

    // 同時登録の時に必須にするためクライアント側でチェックを行う
    if (account.tel === '') {
      let payload = {
        errors: {
          tel: i18n.t('page.formError.tel'),
        },
      }
      return actions.setAccount(payload)
    }

    if (account.acceptTermOfHost && account.acceptTermOfService) {
      const queries = queryString.parse(new URL(config.URL).search)
      const options = {
        done: queries.done,
        serviceId: queries.serviceId,
        referralToken: queries.referred_by,
        source: queries.utm_source,
        medium: queries.utm_medium,
        term: queries.utm_term,
        campaign: queries.utm_campaign,
      }
      const restClient = this.props.restClient
      return actions.hostSignUp({ restClient, account, options })
    } else if (!account.acceptTermOfHost && !account.acceptTermOfService) {
      let payload = {
        errors: {
          accept_term_of_service: i18n.t(
            'page.formError.notAcceptTermOfService',
          ),
          accept_term_of_host: i18n.t('page.formError.notAcceptTermOfHost'),
        },
      }
      return actions.setAccount(payload)
    } else if (!account.acceptTermOfHost) {
      let payload = {
        errors: {
          accept_term_of_host: i18n.t('page.formError.notAcceptTermOfHost'),
        },
      }
      return actions.setAccount(payload)
    } else if (!account.acceptTermOfService) {
      let payload = {
        errors: {
          accept_term_of_service: i18n.t(
            'page.formError.notAcceptTermOfService',
          ),
        },
      }
      return actions.setAccount(payload)
    }
  }

  onHostRegistrationClick() {
    const { account, actions, config } = this.props
    const queries = getAccountQueries(config.URL)
    const options = {
      done: queries.done,
      serviceId: queries.serviceId,
      referralToken: queries.referred_by,
    }
    const restClient = this.props.restClient
    const currentUser = this.props.data?.viewer
    if (currentUser) {
      return actions.hostSignUp({ restClient, account, options, currentUser })
    } else {
      const myMain = document.getElementById('applyhost')
      const rect = myMain.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      let myTop
      if (window.innerWidth > 768) {
        myTop = rect.top + scrollTop - 112
      } else {
        myTop = rect.top + scrollTop - 88
      }
      window.scrollTo(0, myTop)
    }
  }

  render() {
    const { hostSimulation, ui } = this.props
    const config = this.props.config

    const ownerName = this.props.account.ownername
    if (this.props.account.isSuccess && ownerName) {
      if (ui.isSubmitFromForm) {
        return <Redirect to={'/sign_up/sent'} />
      } else {
        let owner = {}
        owner.username = ownerName
        return <Redirect to={Path.dashboard(owner, '/rooms')} />
      }
    }

    return (
      <AccountTemplate
        {...this.props}
        isShowZendeskChat
        title={i18n.t('page.hostEntry.ogTitle')}
        description={i18n.t('page.hostEntry.ogDescription')}
        url={i18n.t('page.hostEntry.ogUrl')}
        image={i18n.t('page.hostEntry.ogImage')}
        siteName={i18n.t('page.hostEntry.ogSiteName')}
        isHostEntryPage
      >
        {ui.isLoading && <LoadingView />}
        <HostEntryPage
          prefectureSelectProps={{
            value: hostSimulation.prefecture,
            onChange: (value) => {
              this.resetSimulator({ prefecture: value })
            },
          }}
          prefectureOptionList={prefectureOptionList}
          regionSelectProps={{
            value: hostSimulation.region,
            onChange: (value) => {
              this.refetchSimulator({ region: value })
            },
          }}
          regionOptionList={this.getRegionList()}
          capacitySelectProps={{
            value: hostSimulation.capacity,
            onChange: (value) => {
              this.refetchSimulator({ capacity: value })
            },
          }}
          capacityOptionList={capacityOptionList}
          price={hostSimulation.price}
          currentUser={this.props.data?.viewer}
          onSubmit={this.onSubmit}
          onChange={this.onChange}
          onHostRegistrationClick={this.onHostRegistrationClick}
          account={this.props.account}
        />
      </AccountTemplate>
    )
  }
}

const hostEntryQuery = gql`
query HostEntryPage {
  viewer {
    ${viewerFragment}
  }
}
`

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setAccount: accountActions.setAccount,
    setUIState,
    hostSignUp: accountActions.hostSignUp,
    ...hostSimulationActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const withData = graphql(hostEntryQuery, {
  skip: checkTokenExpired(),
})
export default withPage(
  HostEntryPageContainer,
  mapStateToProps,
  mapDispatchToProps,
  {
    graphql: withData,
  },
)
